import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const LessonTabs = () => {
  const { courseSlug, sectionId, lessonId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Determine which tab is active based on the current URL
  const isWorkspaceTab = location.pathname.includes("/progress");
  const activeTab = isWorkspaceTab ? "coding-workspaces" : "lesson-plan";

  const handleTabChange = (value: string) => {
    if (value === "coding-workspaces") {
      navigate(
        `/course/${courseSlug}/section/${sectionId}/lesson/${lessonId}/progress`,
      );
    } else {
      navigate(`/course/${courseSlug}/section/${sectionId}/lesson/${lessonId}`);
    }
  };

  return (
    <Tabs
      value={activeTab}
      className="w-full mb-6"
      onValueChange={handleTabChange}
    >
      <TabsList className="w-full">
        <TabsTrigger value="lesson-plan" className="flex-1">
          Lesson Plan
        </TabsTrigger>
        <TabsTrigger value="coding-workspaces" className="flex-1">
          Coding Workspaces
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default LessonTabs;
